'use client';

import type { ReactElement } from 'react';
import type { Brand, Region } from '@/types/constants';
import { GameUrl } from '@/app/components/game/subcomponents/game-url/game-url';
import { useGlobalContext } from '@/store/contexts/global-context';
import type { PlaytechGameConfig } from '@/logic/playtech-enrollment/find-playtech-game';
import type { LauncherUrlProps } from '@/utils/url/launcher-url';

export type PlaytechGameLauncherProps = {
    children: ReactElement;
    gameConfig: PlaytechGameConfig;
    className?: string;
    module?: string;
    onGameLaunch?: () => void;
};

export const PlaytechGameLauncher: React.FC<PlaytechGameLauncherProps> = ({
    children,
    gameConfig,
    className,
    module,
    onGameLaunch
}) => {
    const { region } = useGlobalContext();
    const brand = process.env.BRAND as Brand;

    const launcherUrlProps: LauncherUrlProps = {
        ...gameConfig,
        region: region as Region,
        brand
    };

    return (
        <GameUrl
            launcherUrlProps={launcherUrlProps}
            gameUid={gameConfig.gameUid}
            gameId={gameConfig.gameId}
            gameName={gameConfig.gameName}
            className={className}
            module={module ?? 'playtech-enrollment'}
            onLauncherClick={onGameLaunch}>
            {children}
        </GameUrl>
    );
};
